/**
 * The social windows of WINDOW_REGISTRY (plan 27 wave 3, lane BM; registry.ts
 * spreads them in after the GM windows). Pure data, ZERO React — same rules
 * as registry.ts.
 */

import type { WindowDef } from './types';

export const SOCIAL_WINDOW_DEFS: readonly WindowDef[] = [
  {
    kind: 'gameplay',
    id: 'leaderboard',
    label: 'Leaderboard',
    icon: '🏅',
    description: 'Top characters on the server by level, then XP (guests, GM and test characters left out), and who is online now with calling, level and zone. Plan 23 row 40.',
    defaultSize: { width: 520, height: 560 },
    minSize: { width: 360, height: 320 },
    category: 'game',
    persist: false,
  },
  {
    kind: 'gameplay',
    id: 'inspect',
    label: 'Inspect',
    icon: '🔍',
    description: 'The public sheet of another player — calling, level, worn equipment (item tooltips on hover) and key stats — from the server inspectPlayer reply. Opened from the target frame. Plan 23 row 34.',
    defaultSize: { width: 440, height: 560 },
    minSize: { width: 340, height: 360 },
    category: 'game',
    persist: false,
  },
  {
    kind: 'gameplay',
    id: 'chestLoot',
    label: 'Loot',
    icon: '🧰',
    description: 'What a world chest holds — item, rarity and tooltip — with Take all. Opened by ChestPresenter from the server openChest reply; the takeChest reply grants and claims (DJ 2026-10-23).',
    defaultSize: { width: 400, height: 380 },
    minSize: { width: 320, height: 280 },
    category: 'game',
    persist: false,
  },
];
